// extracted by mini-css-extract-plugin
export default {"form":"profile-section_form__2xt72","info":"profile-section_info__MkIj3","fields":"profile-section_fields__tMmLN"};